const TIMEOUT = 5000;
const HOST = 'https://api2.bcm.luxtag.io';

const config = {
  timeout: TIMEOUT,
  host: HOST
};

export default config;
